import React from "react";
import { PlanningTemplate } from "./PlanningTemplate";
import { QuarterFilters } from "./QuarterFilters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./quarterExternalHelpers";
import { QuarterNavigationFilter } from "components/filters/components/QuarterNavigationFilter";
import { useLoaderData } from "react-router";
import TrainModal from "train/TrainModal";

export const PlanningQuarterExternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.QuarterViewForExternalFrontModel>();

  return <>
    <TrainModal />
    <PlanningTemplate
      quarterly
      filterSet="planning_Quarter"
      initialInstruction={viewModel.initialInstruction}
      defaultFilters={viewModel.defaultFilters}
      fetchFunction={window.CoreApi.Planning.PlanningByQuarterForExternal}
      mapFilterValuesToInstruction={mapFilterValuesToInstruction}
      mapResponseToFilterValues={mapResponseToFilterValues}
      filterComp={<QuarterFilters external />}
      paginationComp={<QuarterNavigationFilter />}
      exportOptions={{
        canExportList: site.permissions.show.canExportList,
        exportOptionsApi: () => window.CoreApi.Planning.PlanningByQuarterExportOptions(),
      }}
    />
  </>
};

export const PlanningQuarterInternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.QuarterViewForInternalFrontModel>();

  return <>
    <TrainModal />
    <PlanningTemplate
      quarterly
      filterSet="planning_Quarter"
      initialInstruction={viewModel.initialInstruction}
      defaultFilters={viewModel.defaultFilters}
      fetchFunction={window.CoreApi.Planning.PlanningByQuarterForInternal}
      mapFilterValuesToInstruction={mapFilterValuesToInstruction}
      mapResponseToFilterValues={mapResponseToFilterValues}
      filterComp={<QuarterFilters />}
      paginationComp={<QuarterNavigationFilter />}
      filterPreset={{
        mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForPlanningByQuarter,
        listApi: window.CoreApi.FilterPreset.ListFilterPresetsForPlanningByQuarter,
      }}
      exportOptions={{
        canExportList: site.permissions.show.canExportList,
        exportOptionsApi: () => window.CoreApi.Planning.PlanningByQuarterExportOptions(),
      }}
    />
  </>
};
